import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface JoinChimeStore {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const useJoinChimeStore = create<JoinChimeStore>()(
  persist(
    (set) => ({
      enabled: true,
      setEnabled: (enabled: boolean) => set({ enabled }),
    }),
    {
      name: "join-chime-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
